<template>
  <v-form v-model="validForm">
    <v-card flat class="fill-height">
      <v-card-title class="pt-1 pb-0 ">

        <provider-title title="Cuenta de Cobro" />

        <v-spacer></v-spacer>

          <v-chip v-if="!paymentAccountWasSet" color="secondary" dark outlined>
            Sin configurar
            <v-icon right class="ml-1 mr-0" size="16">far fa-sticky-note</v-icon>
          </v-chip>
          <v-chip v-else-if="!verified" color="accent" dark outlined>
            Esperando verificación
            <v-icon right class="ml-1 mr-0" size="14">fa-hourglass-half</v-icon>
          </v-chip>
          <v-chip v-else color="success" dark outlined>
            Verificada
            <v-icon right class="ml-2">fa-check-circle</v-icon>
          </v-chip>

      </v-card-title>
      <v-alert v-if="!isOwner" :value="true" type="info" outlined color="secondary" class="body-1">
        Solo el dueño de la cuenta tiene acceso a esta pantalla
      </v-alert>
      <v-card-text v-else>

        <div class="text-center my-4" v-if="!allowOnlinePayments">
          <div class="body-2"> Tu plan actual no incluye cobros en línea.</div>
          ¿Necesitas esta característica?
          <br/>
          <buy-new-plan-btn />
        </div>

        <template v-else>
          <v-layout wrap>

            <template v-if="!paymentAccountWasSet">
              <v-flex xs12>
                <provider-sub-title text="Importante"></provider-sub-title>
              </v-flex>
              <v-flex xs12 class="mb-3">
                <v-alert color="secondary" outlined :value="true" style="border-radius: 10px">
                  Nuestra plataforma de pagos esta potenciada por <a class="mx-2" style="color: black;" href="https://cl.khipu.com/" target="_blank"><img src="@/assets/img/khipu.png" width="40"></a>,
                  por lo que, luego de completar la información a continuación, deberas seguir las instrucciones enviadas a tu correo.
                  Es importante que estes seguro(a) de los datos a configurar, pues estos <b>no podrán ser modificados</b> posteriormente.
                </v-alert>
              </v-flex>
            </template>

            <template v-if="paymentAccountWasSet && !verified">
              <v-flex xs12>
                <provider-sub-title text="Importante"></provider-sub-title>
              </v-flex>
              <v-flex xs12 class="mb-3">
                <v-alert type="info" color="accent"  :value="true" style="border-radius: 10px">
                  ¡Tu <b>Cuenta de Cobro</b> ha sido creada!. Sigue las instrucciones enviadas a tu correo para validarla.
                </v-alert>
              </v-flex>
            </template>

            <template v-if="paymentAccountWasSet && verified">
              <v-flex xs12>
                <provider-sub-title text="Importante"></provider-sub-title>
              </v-flex>
              <v-flex xs12 class="mb-3">
                <v-alert color="success" type="success"  :value="true" style="border-radius: 10px">
                  ¡Tu <b>Cuenta de Cobro</b> esta operativa!.
                </v-alert>
              </v-flex>
            </template>

            <v-flex xs12>
              <provider-sub-title text="Datos de Facturación"></provider-sub-title>
            </v-flex>

            <!--<v-flex xs12>
              <v-radio-group v-model="type" row class="mt-1">
                <v-radio label="Persona" value="Persona"></v-radio>
                <v-radio label="Empresa" value="Empresa"></v-radio>
              </v-radio-group>
            </v-flex>-->

            <v-layout wrap>
              <v-flex xs12 md6 pa-1>
                <v-text-field
                    :disabled="paymentAccountWasSet"
                    :clearable="!paymentAccountWasSet"
                    hide-details
                    outlined
                    label="Nombre"
                    placeholder="Ej. Acme S.A., Juan Perez, etc."
                    :rules="nameRules"
                    @click:clear="business_name = ''"
                    :value="business_name"
                    :max="9"
                    @input="value => business_name = value"
                >
                  <template v-slot:prepend-inner="">
                    <v-icon size="22" class="mr-1">fa-store</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6 pa-1>
                <v-text-field
                    :disabled="paymentAccountWasSet"
                    :clearable="!paymentAccountWasSet"
                    hide-details
                    outlined
                    label="RUT"
                    :rules="rutRules"
                    :maxlength="12"
                    @click:clear="business_identifier = ''"
                    :value="business_identifier | rut"
                    @input="value => business_identifier = value.replace(/(\.|\-)/g, '')"
                >
                  <template v-slot:prepend-inner="">
                    <v-icon size="22" class="mr-1">fa-id-card</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 md6 pa-1>
                <v-text-field
                    :disabled="paymentAccountWasSet"
                    :clearable="!paymentAccountWasSet"
                    hide-details
                    outlined
                    label="Teléfono"
                    :rules="phoneRules"
                    @click:clear="business_phone = ''"
                    :value="business_phone"
                    :prefix="!paymentAccountWasSet ? '+56': ''"
                    @input="value => business_phone = value"
                >
                  <template v-slot:prepend-inner="">
                    <v-icon size="22" class="mr-1">fa-phone</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6 pa-1>
                <v-text-field
                    v-if="paymentAccountWasSet"
                    disabled
                    :value="fullAddress"
                    outlined
                    label="Dirección"
                >
                  <template v-slot:prepend-inner="">
                    <v-icon size="22" class="mr-1">fa-map-marker-alt</v-icon>
                  </template>
                </v-text-field>
                <location-picker
                    v-else
                    :error-messages="addressError"
                    :disabled="paymentAccountWasSet"
                    :required="true"
                    @change="onLocationChange"
                    :outline="true"
                    prepend-icon="fa-map-marker-alt" />
              </v-flex>
            </v-layout>

          </v-layout>

          <v-layout wrap>

            <v-flex xs12 mt-4>
              <provider-sub-title style="margin-bottom: 0 !important" text="Contacto" />
              <div class="caption py-0">¿A quién contactamos en caso de problemas?</div>
            </v-flex>

            <v-layout wrap class="mt-3">
              <v-flex xs12 md6 pa-1>
                <v-text-field
                    :disabled="paymentAccountWasSet"
                    :clearable="!paymentAccountWasSet"
                    hide-details
                    outlined
                    label="Nombre completo"
                    :rules="nameRules"
                    @click:clear="contact_full_name = ''"
                    :value="contact_full_name"
                    @input="value => contact_full_name = value"
                >
                  <template v-slot:prepend-inner="">
                    <v-icon size="22" class="mr-1">fa-user</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6 pa-1>
                <v-select
                    :disabled="paymentAccountWasSet"
                    hide-details
                    outlined
                    label="Cargo"
                    :rules="[v => !!v || 'Campo obligatorio']"
                    :value="contact_job_title"
                    v-model="contact_job_title"
                    :items="jobTitles"
                >
                  <template v-slot:prepend-inner="">
                    <v-icon size="22" class="mr-1">fa-suitcase</v-icon>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12 md6 pa-1>
                <v-text-field
                    :disabled="paymentAccountWasSet"
                    :clearable="!paymentAccountWasSet"
                    hide-details
                    outlined
                    label="E-mail"
                    type="email"
                    :rules="emailRules"
                    @click:clear="contact_email = ''"
                    :value="contact_email"
                    v-model="contact_email"
                >
                  <template v-slot:prepend-inner="">
                    <v-icon size="22" class="mr-1">fa-envelope</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6 pa-1>
                <v-text-field
                    :disabled="paymentAccountWasSet"
                    :clearable="!paymentAccountWasSet"
                    hide-details
                    outlined
                    label="Teléfono"
                    :rules="phoneRules"
                    @click:clear="contact_phone = ''"
                    :value="contact_phone"
                    :prefix="!paymentAccountWasSet ? '+56': ''"
                    @input="value => contact_phone = value"
                >
                  <template v-slot:prepend-inner="">
                    <v-icon size="22" class="mr-1">fa-phone</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>

          </v-layout>
        </template>




      </v-card-text>
      <v-card-actions v-if="allowOnlinePayments && isOwner">
        <v-spacer></v-spacer>
        <v-btn
            v-if="!paymentAccountWasSet"
            :disabled="!validForm"
            color="primary"
            @click="submit"
            :loading="loading">Crear cuenta de cobro</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

import {mapState, mapMutations, mapGetters} from 'vuex'
  import {ApiUtils} from '@/utils/ApiUtils'
  import {rutValidator} from '@/utils/Common'
import BuyNewPlanBtn from "../../subscription/BuyNewPlanBtn";
import ProviderSubTitle from "../panel/ProviderSubTitle";

export default {
  components: {
    ProviderSubTitle,
    BuyNewPlanBtn,
    ProviderTitle: () => import('@/components/providers/panel/ProviderTitle'),
    LocationPicker: () => import('@/components/common/LocationPicker'),
  },
  props: {},
  data() {
    return {

      type: 'Persona',
      bank: null,
      validForm: false,

      bank_account_number: '',
      business_identifier: '',
      business_name: '',
      business_phone: '',
      business_address_line_1: '',
      business_address_line_2: '',
      business_address_line_3: '',
      contact_full_name: '',
      contact_job_title: '',
      contact_email: '',
      contact_phone: '',

      bank_account_bank_id: '',
      bank_account_identifier: '',
      bank_account_name: '',

      loading: false,
      emailRules: [
        v => !!v && /.+@.+/.test(v) || 'E-mail inválido'
      ],
      phoneRules: [
        v => /[1-9]\s?[0-9]{4}\s?[0-9]{3,4}/.test(v) || 'Teléfono inválido'
      ],
      nameRules: [
          v => !!v || 'Campo obligatorio',
          v => !!v && v.length > 2 || 'Mínimo 2 caracteres'
      ],
      accountNumberRules: [
        v => !!v || 'Campo obligarotio',
        v => !!v && v.length > 7 || 'Mínimo 7 caracteres'
      ],
      rutRules: [
        v => !!v && rutValidator(v) || 'RUT inválido'
      ]
    }
  },
  mounted() {
    this.loadDefault()
  },
  computed: {

    ...mapState(['currentUser', 'currentProvider', 'currentBranchOffice']),
    ...mapGetters(['allowOnlinePayments']),
    fullAddress(){
      var vm = this
      return `${vm.business_address_line_1}, ${vm.business_address_line_2}, ${vm.business_address_line_3}.`
    },
    verified(){
      var vm = this
      return !!vm.currentProvider && !!vm.currentProvider.settings.payment_account && vm.currentProvider.settings.payment_account.verified
    },
    jobTitles(){
      var vm = this
      return [
        'Dueño',
        'Contador(a)',
        'Otro'
      ]
    },
    addressError(){
      var vm = this
      if(
          vm.business_address_line_1.length < 4 ||
          vm.business_address_line_2.length < 4 ||
          vm.business_address_line_3.length < 4
      ){
        return 'Campo Obligatorio'
      }else{
        return ''
      }
    },
    defaultAddressLine1(){
      var vm = this
      if(!vm.currentBranchOffice) return ''

    },

    defaultAddressLine2(){
      var vm = this
      if(!vm.currentBranchOffice) return ''
    },

    defaultAddressLine3(){
      var vm = this
      if(!vm.currentBranchOffice) return ''
    },

    isInstitution(){
      var vm = this
      return !!vm.currenProvider && !!vm.currentProvider.institution
    },

    paymentAccountWasSet(){
      var vm = this
      const {settings: {payment_account}} = vm.currentProvider
      return !!payment_account
    },

    valid(){
      var vm = this

      return true
    },
    payload(){

      var vm = this

      return {
        business_identifier: vm.business_identifier || '',
        business_name: vm.business_name || '',
        business_phone: vm.business_phone || '',
        business_address_line_1: vm.business_address_line_1 || '',
        business_address_line_2: vm.business_address_line_2 || '',
        business_address_line_3: vm.business_address_line_3 || '',
        contact_full_name: vm.contact_full_name || '',
        contact_job_title: vm.contact_job_title || 'Dueño',
        contact_email: vm.contact_email || '',
        contact_phone: vm.contact_phone || '',

        bank_account_bank_id: !!vm.bank && vm.bank.bank_id || '',
        bank_account_identifier: vm.business_identifier || '',
        bank_account_name: !!vm.bank && vm.bank.name || '',
        bank_account_number: vm.bank_account_number || ''
      }

    }
  },
  methods: {
    ...mapMutations(['showSnackBar']),
    onLocationChange(location){
      var vm = this
      if(!location){
        vm.business_address_line_1 = ''
        vm.business_address_line_2 = ''
        vm.business_address_line_3 = ''
      }else{
        vm.business_address_line_1 = location.address.street && `${location.address.street} ${location.address.number}` || location.address.full || ''
        vm.business_address_line_2 = location.address.commune || location.address.province || ''
        vm.business_address_line_3 = location.address.region || ''
      }

    },
    loadDefault(){

      var vm = this
      const {settings: {payment_account}} = vm.currentProvider

      vm.business_identifier = payment_account && payment_account.business_identifier || ''
      vm.business_name = payment_account && payment_account.business_name ||  ''
      vm.business_phone = payment_account && payment_account.business_phone ||  ''
      vm.business_address_line_1 = payment_account && payment_account.business_address_line_1 ||  ''
      vm.business_address_line_2 = payment_account && payment_account.business_address_line_2 ||  ''
      vm.business_address_line_3 = payment_account && payment_account.business_address_line_3 ||  ''
      vm.contact_full_name = payment_account && payment_account.contact_full_name ||  ''
      vm.contact_job_title = payment_account && payment_account.contact_job_title ||  'Dueño'
      vm.contact_email = payment_account && payment_account.contact_email ||  ''
      vm.contact_phone = payment_account && payment_account.contact_phone ||  ''

      vm.bank = {
        bank_id: payment_account && payment_account.bank_account_bank_id ||  '',
        name: payment_account && payment_account.bank_account_name || ''
      }

      vm.bank_account_identifier = payment_account && payment_account.bank_account_identifier || ''
      vm.bank_account_number = payment_account && payment_account.bank_account_number || ''

    },
    async submit() {

      var vm = this
      if (!vm.validForm) return

      const { id } = vm.currentProvider
      this.loading = true
      const response = await ApiUtils.makePost(`provider/${vm.currentProvider.id}/payment/account`, vm.payload)

      if (!response.ok){
        this.loading = false
        const json = await response.json()
        return vm.$store.commit('showSnackBar', {
          text: json.message ||'Error intentando procesar la solicitud',
          color: 'error'
        })

      }
      await ApiUtils.fetchMe()
      this.loading = false

    }
  },
  watch:{
    type(val){
      var vm = this
      vm.$refs.bankPicker.reset()
    }
  }
}
</script>
<style scoped>
.ancho {
  max-width: 300px;
}
</style>
